export default __webpack_public_path__ + "static/media/5.c9c38fb9.png";